import { Component, OnInit, OnDestroy } from '@angular/core';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { Router } from '@angular/router'
import { AuthService } from 'app/shared/services/auth/auth.service';
import { SocketService } from 'app/shared/services/socket.service';
@Component({
  selector: 'app-mobile-footer',
  templateUrl: './mobile-footer.component.html',
  styleUrls: ['./mobile-footer.component.css']
})
export class MobileFooterComponent implements OnInit,OnDestroy {

  public activeTab = 'feed';
  Allobservables: any;
  constructor(
    public navBar:MobileNavService,
    public activeRouter:Router,
    public authService:AuthService,
    public socketService:SocketService
  ) { }

  ngOnInit() {

    this.activeRouter.events.subscribe((newroute) => {
      if(!newroute['url']){
      }else if(newroute['url'].indexOf('associate/feed') !== -1 ){
        this.activeTab = 'feed';
      } else if(newroute['url'].indexOf('home/associate') !== -1 ) {
        this.activeTab = 'associate'
      } else if(newroute['url'].indexOf('home/organization') !== -1 ) {
        this.activeTab = 'organization'
      } else if(newroute['url'].indexOf('home/list') !== -1 ) {
        this.activeTab = 'list'
      } else{
        this.activeTab = '';
      }

    });
  }

  sideBar(){
    this.navBar.showSideNav();
  }

  // socketLisner(){
  //   const obs1=  this.socketService.initObs.subscribe(res=>{
  //       if(res){
  //           this.socketService.sendInit(this.authService.user.associateId);
  //       }
  //   });
  //   this.Allobservables.push(obs1);
  // }

  ngOnDestroy(): void {
    this.socketService.disconnect(this.authService.user.associateId);
    if (this.Allobservables) {
      this.Allobservables.forEach(obs=>{
        obs.unsubscribe();
    })
    }
  }

}
